export const MAP_STYLE_URL = `${import.meta.env.VITE_APP_ORIGIN}/api/map-style`
